import { decorate, action, observable } from "mobx";
import axios from 'axios';


class Translator  {

    results = [];
    error = null;
    
    translate(value) {
        this.awaitingUserSelection=false;
        this.originalVal = value;
        this.error = null;
        this.results = [];
        
        var p = axios.get("https://api.mymemory.translated.net/get?q="+encodeURIComponent(value)+"&langpair=he|en")
        .then((response) => {
            
            this.results = response['data']['matches']
            .filter(r => 
                (r['segment'] === this.originalVal))
            .map(r => 
                ({
                    "translation" : r['translation'],
                    "quality" : r['quality']
                }))
            this.originalVal = null;
                  
        })
        .catch(error => {
            console.log(error);
            this.originalVal = null;
            this.err = error;
            this.results = [];
            throw error;
        });
        return p;

        
    }
    
}

decorate (Translator, {
    translate: action.bound,
    results : observable,
    selectedTranslation: observable,
});

export default Translator;